import { Box, Card, CardContent, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import AddressBlock from './AddressBlock';
import DistanceIndicator from './DistanceIndicator';
import PhoneNumberLink from '@src/components/PhoneNumberLink';
import { OfficeSearchApiResponse } from '@src/lib/__generated/api';
export default function Location({
  location,
  children,
  primaryLocation = false
}: Readonly<{
  location: OfficeSearchApiResponse;
  children: ReactNode;
  primaryLocation?: boolean;
}>) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return <Card elevation={0} sx={{
    borderWidth: '1px',
    borderStyle: `${primaryLocation ? 'none' : 'solid'}`,
    borderColor: 'neutrals.primary',
    bgcolor: !primaryLocation && isSmallScreen ? 'backgrounds.neutral' : 'backgrounds.defualt'
  }} data-sentry-element="Card" data-sentry-component="Location" data-sentry-source-file="Location.tsx">
			<CardContent sx={{
      pt: 2,
      px: primaryLocation && isSmallScreen ? 0 : 1
    }} data-sentry-element="CardContent" data-sentry-source-file="Location.tsx">
				{primaryLocation ? null : <Box pl={isSmallScreen ? 0 : 4} mb={4}>
						<Stack direction="row" justifyContent="space-between">
							<Typography variant="header4">{location.title}</Typography>
							<DistanceIndicator distance={location.distance} />
						</Stack>
						<Stack>
							<AddressBlock address={location.address} zipCode={location.zipCode} />
							<Box>
								<PhoneNumberLink phoneNumber={location.phone ?? ''} variant="bodyMediumBook" />
							</Box>
						</Stack>
					</Box>}
				{children}
			</CardContent>
		</Card>;
}